import "./src/utilities/fonts.css"

export const onClientEntry = () => {
  let body = document.getElementsByTagName("body")[0]
  body.classList.add("page-has-loaded")
}
